import { findIn } from '../../app/helpers/entity'
import { isTvDip } from '../../app/helpers/fn'
import {
  SET_PRICING_PAYMENT_METHOD_TYPES,
  SET_PRICING_PAYMENT_METHOD_TYPES_LABELS
} from '../../app/core/constants'

/**
 * AddChannelSetCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')
AddChannelSetCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * @param $uibModal
 * @param {models.LiveEventSet} cs
 * @param item
 * @param {(function(boolean=): Promise<unknown>)|(function(): void)|*} checkIntersection
 * @param windowClass
 */
export const openCSModal = function ($uibModal, cs, item, checkIntersection, windowClass = 'modal-class-conflict') {
  item.openConflict = true

  $uibModal.open({
    templateUrl: 'components/packages/popups/contentSetsModal.html',
    controller: 'ContentSetsModalCtrl as vm',
    windowClass: 'modal-class-conflict',
    backdrop: true,
    animation: false,
    resolve: {
      cs: function () {
        return cs
      },
      item: function () {
        return item
      },
      checkIntersection: function () {
        return checkIntersection
      }
    }
  })
    .result
    .then(
      function close () {
      },
      function dismiss () {
        item.openConflict = false
      })
}

/**
 * Checking Content Set on intersection
 *
 * @param $http
 * @param alertLiteSvc
 * @param cs
 * @param assigned
 * @param isNew
 * @returns {*|Promise<unknown>}
 */
export const checkCSIntersection = function ($http, alertLiteSvc, cs, assigned, isNew) {
  if (!assigned.length || isNew) { return Promise.resolve(false) }

  const url = cs.$_contentIntersectionUrlTemplate(cs)
  const params = { ids: assigned.map(({ id }) => id) }
  if (cs.$setType === 'tv_show') {
    params.itemType = cs.itemType
  }
  const conflictsByItemId = {}

  return $http.get(url, { params })
    .data()
    .then((resp) => resp.payload)
    .then((data) => {
      data.forEach(item => {
        if (!conflictsByItemId[item.contentId]) { conflictsByItemId[item.contentId] = {} }
        conflictsByItemId[item.contentId][item.contentSetId] = {
          name: item.contentSetName,
          subscriptions: [item, ...(conflictsByItemId[item.contentId][item.contentSetId]?.subscriptions || [])]
        }
      })
    })
    .then(() => {
      assigned.forEach(item => {
        item.conflicts = conflictsByItemId[item.id]
        item.conflictsQuantity = !!conflictsByItemId[item.id] && Object.keys(conflictsByItemId[item.id]).length
      })
      return !!Object.keys(conflictsByItemId).length
    })
    .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
}

/**
 *
 * @param $uibModal
 * @param cs
 * @param {*} assignedSubscriptions
 * @param {*} assignedItems
 * @param {*[]} cachedItemsIds
 */
export const newItemPriceError = function ($uibModal, cs, assignedSubscriptions, assignedItems, cachedItemsIds) {
  const initialSubs = []
  let displayedSubscriptions = []
  let newItems = []
  angular.copy(assignedSubscriptions, initialSubs)
  if (cs.pricing.currency) {
    displayedSubscriptions = assignedSubscriptions.filter(sub => {
      const correctedRent = !sub.perItemRentPriceRequired || (sub.rent && sub.rent.amount)
      const correctedBuy = !sub.perItemBuyPriceRequired || (sub.buy && sub.buy.amount)
      if (correctedRent && correctedBuy) {
        return false
      }
      const correctCurrency = sub.currency.id === cs.pricing.currency.id
      const correctRent = !sub.perItemRentPriceRequired || (cs.$rentEnabled && cs.pricing.rent && cs.pricing.rent.paymentMethod === 'PER_ITEM') || (sub.rent && sub.rent.amount)
      const correctBuy = !sub.perItemBuyPriceRequired || (cs.$buyEnabled && cs.pricing.buy && cs.pricing.buy.paymentMethod === 'PER_ITEM') || (sub.buy && sub.buy.amount)
      return !(correctCurrency && correctRent && correctBuy)
    })
    newItems = assignedItems.filter(item => !cachedItemsIds.includes(item.id))
  }
  if (displayedSubscriptions.length > 0 && newItems.length > 0) {
    return $uibModal.open({
      templateUrl: 'components/packages/views/newItemsPrice.html',
      controller: 'NewItemsPriceCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        subscriptions: function () {
          return displayedSubscriptions
        },
        cs: function () {
          return cs
        }
      }
    }).result
      .then(
        function close (correctedSubscriptions) {
          assignedSubscriptions.forEach(subscription => {
            const correctedSubscription = correctedSubscriptions.find(sub => sub.id === subscription.id)
            if (correctedSubscription) {
              subscription = { ...correctedSubscription }
            }
          })
        },
        function dismiss () {
          angular.copy(initialSubs, assignedSubscriptions) // restore pricing
          return Promise.reject('dismiss')
        })
  }
  return Promise.resolve()
}
/**
 * AddChannelSetCtrl controller
 *
 * @class AddChannelSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin*
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddChannelSetCtrl
 */
/* @ngInject */
export default function AddChannelSetCtrl ($http, $scope, $location, $uibModal, ChannelSet, NetworkCurrency, alertLiteSvc, cs, pckg) {
  var vm = this
  vm.channelSetTypes = ['TV', 'Radio']
  vm.ready = false

  vm.notTvDip = !isTvDip()

  vm.set_pricing_payment_method_types = angular.copy(SET_PRICING_PAYMENT_METHOD_TYPES)
  vm.set_pricing_payment_method_types_labels = angular.copy(SET_PRICING_PAYMENT_METHOD_TYPES_LABELS)
  vm.types = Object.keys(vm.set_pricing_payment_method_types)
  if (window.ENV.APP_CS_PER_ITEM_ENABLED !== 'true') {
    vm.types = ['PER_SET']
  }

  /**
   * Channel Set
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {models.ChannelSet}
   */

  vm.cs = cs

  if (!vm.cs.id) {
    vm.cs.type = 'TV'
  }

  vm.cachedAssignedItemsIds = vm.cs.channels.map((ch) => ch.id)

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  const networkId = vm.pckg.id

  /**
   * Currencies list
   *
   * @memberof mwApp/settings.controller:PaymentSystemCtrl
   * @name vm.currencies
   * @type {models.NetworkCurrency[]}
   */

  // load currencies
  NetworkCurrency.loadAll({ network: pckg })
    .then(data => data.filter(c => c.enabled))
    .to(vm.currencies = [])
    .then(() => {
      vm.cs.pricing.currency = vm.cs.pricing.currency
        ? findIn(vm.currencies)(vm.cs.pricing.currency)
        : vm.currencies[0]
    })
    .finally(() => { vm.extraLoaded = true })

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {Boolean}
   */
  vm.isNew = cs._isNew()

  /**
   * Filter value for channel sets
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {string}
   */
  vm.filter = ''

  /**
   * Filter value for assigned Channels
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {string}
   */
  vm.filterAssigned = ''

  /**
   * Filter assigned channels
   *
   * @param {ChannelSet} ch
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   */
  vm.filteredAssignedChannels = function (ch) {
    return vm.filterAssigned.length > 0
      ? ch.name.toLowerCase().includes(vm.filterAssigned.toLowerCase())
      : true
  }

  /**
   * Items arrays
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {Object}
   */
  vm.items = {
    available: {
      name: 'available',
      channels: []
    },
    assigned: {
      name: 'assigned',
      channels: []
    }
  }

  vm.removedItems = []

  /**
   * Table state
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {Object[]}
   */
  vm.channelDefaultPagination = {
    q: '',
    page: 0,
    last: false,
    count: 25,
    'exclude-channelset-id': vm.cs.id || 0
  }

  vm.searchContentAvailableParams = angular.copy(vm.channelDefaultPagination)

  /**
   * Get assigned channels
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {Object[]}
   */
  if (!vm.isNew) { // TODO: refactoring
    vm.items.assigned.channels = vm.cs.channels
    vm.cs.channels.forEach(ch => {
      vm.removedItems.push(ch.id)
    })
  }

  /**
   * get available channels
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   * @type {Object[]}
   */
  vm.getAvailableChannels = function () {
    vm.cs._getAvailableChannels(networkId, vm.cs.type, { ...vm.channelDefaultPagination, q: vm.filter })
      .then((result) => {
        vm.items.available.channels = result.content.filter(c => !vm.items.assigned.channels.find(ac => ac.id === c.id))
        vm.searchContentAvailableParams.last = result.last
        vm.searchContentAvailableParams.page = 0
      })
  }
  vm.getAvailableChannels()

  vm.saveSet = function () {
    vm.setDisable()
    cs._save((data) => {
      data.addedItems = []
      vm.items.assigned.channels.forEach(channel => {
        data.addedItems.push(channel.id)
      })
      if (!vm.isNew) {
        data.removedItems = vm.removedItems.filter(ch => !data.addedItems.includes(ch))
      }
    })
      .then((res) => {
        cs._update().then(() => {
          if (vm.isNew) {
            $location.url(cs._publicListUrl + res.data.payload.id)
          }
        })
      })
      .then(vm.location(cs).reload)
      .finally(vm.unsetDisable)
  }

  /**
   * Create or edit coupon, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   */
  vm.submit = function () {
    if (vm.items.assigned.channels.length === 0) {
      return
    }

    vm.checkIntersection()
      .then(
        () => {
          newItemPriceError($uibModal, cs, cs.assignedSubscriptions, vm.items.assigned.channels, vm.cachedAssignedItemsIds)
            .then(() => { vm.saveSet() })
        })
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @param event
   */
  vm.$timerContentAvailableScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    const {
      last
    } = vm.searchContentAvailableParams
    if (!last && event.wheelDelta < 0 && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAvailableScroll)
      vm.$timerContentAvailableScroll = window.setTimeout(() => {
        vm.searchContentAvailableParams.page++
        vm.cs._getAvailableChannels(vm.pckg.id, vm.cs.type, { ...vm.searchContentAvailableParams, q: vm.filter }).then((result) => {
          vm.items.available.channels = vm.items.available.channels.concat(result.content.filter(c => !vm.items.assigned.channels.find(ac => ac.id === c.id)))
          vm.searchContentAvailableParams.last = result.last
        })
      }, 700)
    }
  }

  // see http://marceljuenemann.github.io/angular-drag-and-drop-lists/demo/#/multi

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index) {
    $scope.form.$setDirty()
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    list.channels = list.channels
      .slice(0, index)
      .concat(items)
      .concat(list.channels.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete show from showSet
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   */
  vm.deleteChannelFromSet = function (channel) {
    event.preventDefault()
    channel.selected = false
    vm.items.assigned.channels = vm.items.assigned.channels.filter(ch => ch.id !== channel.id)
    vm.items.available.channels.push(channel)
    $scope.form.$setDirty()
    vm.checkIntersection(true)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => { item.selected = false })
    list.dragging = false
    vm.checkIntersection()
      .then()
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.channels = list.channels.filter(item => !item.selected)
  }

  /**
   * Method for filtering channels by name
   *
   * @param {ChannelSet} channel
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   */
  $scope.filteredChannels = (channel) => {
    return vm.filter.length > 0
      ? channel.name.includes(vm.filter)
      : true
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddChannelSetCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicUrl + '/contentSets#channel_sets')
    }
  }

  vm.openConflicts = function (item) {
    event.stopPropagation()
    openCSModal($uibModal, vm.cs, item, vm.checkIntersection)
  }

  vm.checkIntersection = function (checkOnDelete = false) {
    if (checkOnDelete && !vm.hasCSintersection) { return }
    vm.setDisable()
    return checkCSIntersection($http, alertLiteSvc, vm.cs, vm.items.assigned.channels, vm.isNew)
      .then(data => {
        vm.hasCSintersection = data
      })
      .catch(() => { vm.hasCSintersection = false })
      .finally(vm.unsetDisable)
  }

  vm.selectType = function (type) {
    vm.cs.type = type
    vm.items.assigned.channels = []
    vm.searchContentAssignedParams = angular.copy(vm.searchContentParams)
    vm.getAvailableChannels()
  }
}
